"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.segment = exports.hotjar = exports.ga = exports.experiment = exports.default = exports.actions = exports.DimensionManager = void 0;
var _GoogleAnalyticsTracking = _interopRequireDefault(require("./GoogleAnalyticsTracking"));
var _HotjarTracking = _interopRequireDefault(require("./HotjarTracking"));
var _Experiment = _interopRequireDefault(require("./Experiment"));
var _Segment = _interopRequireDefault(require("./Segment"));
var _DimensionManager = _interopRequireDefault(require("./DimensionManager"));
var _ActionEvents = _interopRequireDefault(require("./ActionEvents"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ga = _GoogleAnalyticsTracking.default;
exports.ga = ga;
var actions = _ActionEvents.default;
exports.actions = actions;
var hotjar = _HotjarTracking.default;
exports.hotjar = hotjar;
var experiment = _Experiment.default;
exports.experiment = experiment;
var segment = _Segment.default;
exports.segment = segment;
var DimensionManager = _DimensionManager.default;
exports.DimensionManager = DimensionManager;
var _default = {
  ga: ga,
  actions: actions,
  hotjar: hotjar,
  experiment: experiment,
  segment: segment,
  DimensionManager: DimensionManager
};
exports.default = _default;
//# sourceMappingURL=index.js.map